import { Breadcrumbs, Link, Typography } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import { Property } from "../../../../../shared/src/types/property";

interface PropertyBreadcrumbNavProps {
  property: Property;
}

export const PropertyBreadcrumbNav: React.FC<PropertyBreadcrumbNavProps> = ({
  property,
}) => {
  return (
    <Breadcrumbs aria-label="breadcrumb">
      <Link
        component={RouterLink}
        to="/properties"
        underline="hover"
        color="inherit"
      >
        Properties
      </Link>
      <Typography color="text.primary">{property.address}</Typography>
    </Breadcrumbs>
  );
};
